import * as L from 'leaflet';
import type { ControlPosition, PathOptions, MapOptions } from 'leaflet';

/**
 * featureGroup usado para digitalizador de subzonas/zonas especiales
 */
export const featureGroup = new L.FeatureGroup();

/**
 * CONFIG DRAW (tipado correcto Leaflet 21)
 */
export const drawOptions: {
  position: ControlPosition;
  edit: {
    featureGroup: L.FeatureGroup;
  };
  draw: any;
} = {
  position: 'topright',
  edit: {
    featureGroup
  },
  draw: {
    circle: false,
    polyline: false,
    rectangle: false,
    circlemarker: false,
    marker: false,

    polygon: {
      showArea: true,
      precision: {
        km: true
      },
      shapeOptions: {
        color: '#3f51b5',
        fillColor: '#3f51b5',
        opacity: 0.7
      }
    }
  }
};

/**
 * STYLE (CORREGIDO Leaflet PathOptions)
 */
export const style: PathOptions = {
  stroke: true,
  weight: 3,
  color: 'red',
  fillColor: '#a7a7a7',
  fillOpacity: 0.3,
  dashArray: '3,10'
};

/**
 * MAP OPTIONS (Leaflet moderno)
 */
export const mapOptions: MapOptions = {
  layers: [
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {})
  ],
  zoom: 12,
  center: L.latLng([-12.06618091465063, -77.04025268554688])
};